import { Typography } from '@mui/material';
import React from 'react';

type Props = {
    number: string,
    label: string,
    color?: string,
    print?: boolean
}

function DetailInfo({ number, label, color, print }: Props) {
    const isPrint = print || false;
    if (isPrint) {
        return (
            <>
                <div className='rounded shadow text-center p-2'>
                    <Typography variant='h6'>{number}</Typography>
                    <Typography variant='caption'>{label}</Typography>
                    <div className={`${color || 'bg-red-500'} h-0.5 mt-2`}></div>
                </div>
            </>
        );
    } else {
        return (
            <>
                <div className='rounded shadow text-center p-2'>
                    <Typography variant='h5'>{number}</Typography>
                    <Typography variant='caption'>{label}</Typography>
                    <div className={`${color || 'bg-red-500'} h-0.5 mt-2`}></div>
                </div>
            </>
        );
    }
}

export default DetailInfo;
